module.exports = "<mydocma-app-container [options]=\"options\">\r\n\r\n</mydocma-app-container>\r\n"